import { Divider, Row } from "antd";
import { useFetchData } from "./hooks/useFetchData";
import { Loader } from "../../../../../../../../components/Loader";
import { DataRow } from "./components/DataRow";
import "./styles.scss";
import { StartBalances } from "./components/StartBalances";

type TotalsProps = {
  contractId: string;
};

export const Totals = ({ contractId }: TotalsProps) => {
  const { data, isLoading } = useFetchData(contractId);

  return (
    <>
      {isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <Row className="mx-auto totals__container">
          <Divider className="mt-0 mb-4" />

          <DataRow title="Year-to-date" data={data.yearToDate} />

          <DataRow title="Last Year" data={data.lastYear} />

          <StartBalances data={data.lastYear} />
        </Row>
      )}
    </>
  );
};
